import { AuthUser } from '@/types/types';
import { queryClient } from '@/lib/query-client';

import { resetObservability } from './observability';

export async function resetSession() {
  await Promise.all([
    queryClient.setQueryData(['auth'], (prev: AuthUser) => ({ ...prev, user: null })),
    queryClient.removeQueries({ queryKey: ['settings'] }),
  ]);
  resetObservability();
  history.replaceState({}, 'login', '/login');
}
